import { ISkillResource } from "../../skills";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillTranslationList } from "../types";

export interface ISkillTranslationsQueryParameters {
    skill?: RelationalValue<ISkillResource>;
}

export type ISkillTranslationsQueryResult = ISkillTranslationList;

export const skillTranslationsQuery: IApiQueryFunction<ISkillTranslationsQueryParameters> = ({ skill }) => {
    if (!skill) {
        return;
    }

    return {
        method: "GET",
        url: `/skills/${mapRelationalValue(skill)}/translations`,
    };
};

export const useSkillTranslationsQuery = createApiQueryHook<
    ISkillTranslationsQueryParameters,
    ISkillTranslationsQueryResult
>(skillTranslationsQuery);
